import { Box } from '@quintoandar-tokko/jopijs';
import Skeletons from '@/components/Skeletons/Skeletons';
import styles from './styles.module.scss';

export default function LoadingMoreSkeleton({
  rows = 5,
  columns = 1,
  height = 54,
  width = '100%',
}) {
  return Array.from({ length: rows }).map((_, index) => (
    <Box
      as="tr"
      // eslint-disable-next-line
      key={index}
      className={styles.skeletonTR}
    >
      <Box as="td" colSpan={columns} className={styles.skeletonTD}>
        <Skeletons height={height} width={width} borderRadius={4} />
      </Box>
    </Box>
  ));
}
